import { Link } from "react-router-dom";

export const PageTitle = ({ title, crumbs = [] }) => (
  <div className="shadow-[0_6px_6px_-4px_rgba(0,0,0,0.3)] border-b border-gray-200">
    <div className="max-w-[1240px] mx-auto px-4 py-6 lg:py-8 flex flex-col md:flex-row md:items-start justify-between gap-3">
      <h1 data-testid="page-title" className="font-tit font-bold text-[var(--iv)] uppercase text-2xl sm:text-3xl lg:text-[32px] leading-snug max-w-[800px]">{title}</h1>
      <nav className="text-[13px] flex items-center gap-3 shrink-0 md:pt-2" data-testid="breadcrumb">
        <Link to="/" className="font-bold hover:text-[var(--iv)]">Home</Link>
        {crumbs.map((c) => (
          <span key={c.label} className="flex items-center gap-3">
            <span>&gt;</span>
            {c.to ? <Link to={c.to} className="font-bold hover:text-[var(--iv)]">{c.label}</Link> : <span>{c.label}</span>}
          </span>
        ))}
      </nav>
    </div>
  </div>
);
